import { m as f } from "./morph-BgZiyH00.js";
class u {
  #t = new Map();
  #e = new Map();
  #n = new Map();
  #o = null;
  constructor() {
    ((this.#o = new AbortController()),
      window.addEventListener("load", this.#i.bind(this), { signal: this.#o.signal }));
  }
  destroy() {
    (this.#o?.abort(),
      this.#t.clear(),
      this.#e.forEach((t) => t.abort()),
      this.#e.clear(),
      this.#n.clear());
  }
  async renderSection(t, n) {
    const { cache: i = !Shopify.designMode } = n ?? {},
      { url: o } = n ?? {};
    this.#r(t);
    const r = new AbortController();
    this.#e.set(t, r);
    const s = await this.getSectionHTML(t, i, o);
    return (r.signal.aborted || (this.#e.delete(t), g(t, s)), s);
  }
  #r(t) {
    const n = this.#e.get(t);
    n && n.abort();
  }
  async getSectionHTML(t, n = !0, i = new URL(window.location.href)) {
    const o = a(t, i);
    let r = this.#n.get(o);
    if (r) return r;
    if (n) {
      const c = this.#t.get(o);
      if (c) return c;
    }
    ((r = fetch(o).then((c) => c.text())), this.#n.set(o, r));
    const s = await r;
    return (this.#n.delete(o), this.#t.set(o, s), s);
  }
  #i() {
    for (const t of document.querySelectorAll(".shopify-section")) {
      const n = a(t.id);
      if (this.#t.get(n) || d(t)) return;
      this.#t.set(n, t.outerHTML);
    }
  }
}
const l = "shopify-section-";
function a(e, t = new URL(window.location.href)) {
  return (t.searchParams.set("section_id", w(e)), t.searchParams.sort(), t.toString());
}
function h(e) {
  return `${l}${e}`;
}
function w(e) {
  return e.replace(new RegExp(`^${l}`), "");
}
function d(e) {
  return !!e.shadowRoot || Array.from(e.children).some(d);
}
async function g(e, t) {
  const n = new DOMParser().parseFromString(t, "text/html"),
    i = document.getElementById(h(e)),
    o = n.getElementById(h(e));
  if (!i) throw new Error(`Section ${e} not found`);
  if (!o) throw new Error(`Section ${e} not found in the section rendering response`);
  f(i, o);
}
const S = new u();
export { h as b, g as m, S as s };
